import React from "react";
import useSWR from "swr";
import { Link } from "react-router-dom";
import LanguageApi from "./Language";
const Featured = () => {
  const { data, error } = useSWR(process.env.REACT_APP_DEF_URL + "featured");
  const { language_code } = LanguageApi();
  if (error) return <div>failed to load</div>;
  if (!data) return <div>loading...</div>;
  return (
    <>
      {language_code === "tr"
        ? data
          ? data.tr.map((post) => (
              <Link
                className="product-single"
                to={`/product/${post.product_link}`}
              >
                <div className="product-single">
                  <div className="product-image">
                    <img
                      src={process.env.REACT_APP_DEF_URL + post.product_img}
                      alt="product"
                    />
                  </div>
                  <div className="product-text">
                    <p style={{ marginBottom: "8px" }}>{post.product_name}</p>
                    <div className="product-feature">
                      <span>{post.product_future1}</span>
                      <span>{post.product_future2}</span>
                      <span>{post.product_future3}</span>
                    </div>
                  </div>
                </div>
              </Link>
            ))
          : "ürün bulunamadı"
        : data.en.map((post) => (
            <Link
              className="product-single"
              to={`/product/${post.product_link}`}
            >
              <div className="product-single">
                <div className="product-image">
                  <img
                    src={process.env.REACT_APP_DEF_URL + post.product_img}
                    alt="product"
                  />
                </div>
                <div className="product-text">
                  <p style={{ marginBottom: "8px" }}>{post.product_name}</p>
                  <div className="product-feature">
                    <span>{post.product_future1}</span>
                    <span>{post.product_future2}</span>
                    <span>{post.product_future3}</span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
          </>
  );
};

export default Featured;
